<script setup lang="ts">
import { useId } from 'vue'

import Radio from './Radio.vue'
import type { RadioGroupProps, RadioValue } from './types'

const model = defineModel<RadioValue | null>({ default: null })

withDefaults(defineProps<RadioGroupProps>(), {
  disabled: false,
})

const labelId = useId()
const generatedName = useId()
</script>

<template>
  <fieldset
    class="ui-radio-group m-0 flex min-w-0 flex-col gap-xs border-0 p-0 font-sans"
    :disabled="disabled"
    :aria-disabled="disabled"
    :aria-labelledby="labelId"
  >
    <legend
      :id="labelId"
      class="ui-radio-group__label mb-2xs text-fg text-[0.8125rem] font-semibold"
    >
      {{ label }}
    </legend>
    <Radio
      v-for="option in options"
      :key="String(option.value)"
      v-model="model"
      :label="option.label"
      :value="option.value"
      :name="name ?? generatedName"
      :disabled="disabled || option.disabled === true"
    />
  </fieldset>
</template>
